// src/modules/quotes/UpdateQuoteModal.jsx
import { useState } from "react";
import { C } from "../../constants";
import { apiCall } from "../../api";
import { inputStyle, labelStyle, inputFocus, inputBlur } from "../../components/ui/Components";

const UPDATE_TYPES = ["Price Update", "Project Design Update", "Other"];

export default function UpdateQuoteModal({ quote, user, onClose }) {
  const [updateType, setUpdateType] = useState("");
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (!updateType) { setError("Please select an update type."); return; }
    if (!reason.trim()) { setError("Please provide a reason for the update request."); return; }
    setSubmitting(true);
    setError("");
    try {
      const r = await apiCall("submitQuoteUpdateRequest", {
        quoteId: quote.id,
        quoteNumber: quote.quoteNumber,
        updateType,
        reason: reason.trim(),
        requestedBy: user.name,
        requestedByEmail: user.email,
        company: user.company,
      });
      if (r.success) {
        setSubmitted(true);
      } else {
        setError(r.error || "Submission failed. Please try again.");
      }
    } catch (err) {
      setError("Network error. Please try again.");
    }
    setSubmitting(false);
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1100 }}>
      <div style={{ background: C.white, borderRadius: 16, padding: "32px 36px", maxWidth: 480, width: "90%", boxShadow: "0 20px 60px rgba(0,0,0,0.18)" }}>

        {submitted ? (
          /* Success state */
          <div style={{ textAlign: "center" }}>
            <div style={{ width: 64, height: 64, borderRadius: "50%", background: "#D1FAE5", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px", fontSize: 28 }}>✅</div>
            <h3 style={{ fontSize: 18, fontWeight: 700, color: C.t1, margin: "0 0 10px" }}>Update Request Submitted!</h3>
            <p style={{ fontSize: 14, color: C.t2, lineHeight: 1.6, margin: "0 0 24px" }}>
              Your request to update quote <strong>{quote.quoteNumber}</strong> has been received. A Boal Systems team member will review it and get back to you shortly.
            </p>
            <button onClick={onClose}
              style={{ padding: "11px 28px", borderRadius: 8, border: "none", background: C.navy, color: C.white, fontWeight: 600, fontSize: 14, cursor: "pointer", fontFamily: "inherit" }}>
              Close
            </button>
          </div>
        ) : (
          /* Form state */
          <>
            <h3 style={{ fontSize: 18, fontWeight: 700, color: C.t1, margin: "0 0 4px" }}>Request Quote Update</h3>
            <p style={{ fontSize: 13, color: C.t2, margin: "0 0 24px" }}>
              Quote <strong>{quote.quoteNumber}</strong> · {quote.manufacturer}
            </p>

            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              {/* Update type */}
              <div>
                <label style={labelStyle}>Update Type <span style={{ color: C.red }}>*</span></label>
                <select value={updateType} onChange={e => setUpdateType(e.target.value)}
                  style={{ ...inputStyle, appearance: "auto" }} onFocus={inputFocus} onBlur={inputBlur}>
                  <option value="">Select update type...</option>
                  {UPDATE_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                </select>
              </div>

              {/* Reason */}
              <div>
                <label style={labelStyle}>Reason for Update <span style={{ color: C.red }}>*</span></label>
                <textarea
                  value={reason}
                  onChange={e => setReason(e.target.value)}
                  placeholder="Please describe why you need this quote updated..."
                  rows={4}
                  style={{ ...inputStyle, resize: "vertical", lineHeight: 1.5 }}
                  onFocus={inputFocus} onBlur={inputBlur}
                />
                <div style={{ fontSize: 11, color: C.t3, marginTop: 4 }}>{reason.length} characters</div>
              </div>

              {error && (
                <div style={{ background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: C.red }}>
                  {error}
                </div>
              )}
            </div>

            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 24 }}>
              <button onClick={onClose}
                style={{ padding: "10px 20px", borderRadius: 8, border: `1px solid ${C.border}`, background: C.white, color: C.t2, fontSize: 14, cursor: "pointer", fontFamily: "inherit" }}>
                Exit
              </button>
              <button onClick={handleSubmit} disabled={submitting}
                style={{ padding: "10px 24px", borderRadius: 8, border: "none", background: C.navy, color: C.white, fontSize: 14, fontWeight: 600, cursor: submitting ? "not-allowed" : "pointer", fontFamily: "inherit", opacity: submitting ? 0.7 : 1 }}>
                {submitting ? "Submitting..." : "Submit Update Request"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
